import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_1 from '@/app/ui/assets/svg/delete.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_f_warning_circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c1ec14de")

_pushScopeId("data-v-c1ec14de")
const _hoisted_1 = {
  key: 0,
  id: "booking-v4-item-details-section",
  "data-testid": "booking-v4-item-details-section",
  class: "flex flex-col gap-1"
}
const _hoisted_2 = { class: "text-sm font-semibold text-black-lp-300" }
const _hoisted_3 = { class: "item-details-border rounded-xl border overflow-visible" }
const _hoisted_4 = { class: "item-details-table table-fixed w-full text-xs text-gray-lp-300" }
const _hoisted_5 = { class: "item-details-gray-header item-details-header-text text-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("th", { class: "w-12 rounded-tl-xl px-3 py-2 text-center" }, " No. ", -1)
const _hoisted_7 = { class: "item-details-name-column px-2 py-2" }
const _hoisted_8 = { class: "item-details-quantity-column px-2 py-2" }
const _hoisted_9 = { class: "item-details-price-column px-2 py-2" }
const _hoisted_10 = { class: "item-details-total-column px-2 py-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("th", { class: "w-10 rounded-tr-xl" }, null, -1)
const _hoisted_12 = { class: "px-3 py-3 align-top text-center" }
const _hoisted_13 = { class: "px-2 py-2 align-top" }
const _hoisted_14 = { class: "flex w-full items-center justify-between" }
const _hoisted_15 = { class: "ml-1 flex items-center gap-1" }
const _hoisted_16 = {
  key: 0,
  class: "rounded bg-yellow-lp-200 px-1 font-medium text-yellow-lp-100"
}
const _hoisted_17 = {
  key: 1,
  class: "rounded bg-red-lp-600 px-1 font-medium text-red-lp-1600"
}
const _hoisted_18 = {
  key: 0,
  class: "item-details-special-handling z-10 flex items-center gap-1"
}
const _hoisted_19 = {
  key: 0,
  class: "rounded bg-yellow-lp-200 px-1 font-medium text-yellow-lp-100"
}
const _hoisted_20 = {
  key: 1,
  class: "rounded bg-red-lp-600 px-1 font-medium text-red-lp-1600"
}
const _hoisted_21 = {
  key: 1,
  class: "pointer-events-none absolute bottom-1 left-3 text-10px leading-none text-gray-lp-600"
}
const _hoisted_22 = {
  key: 0,
  class: "item-details-error-message"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "error"
}, null, -1)
const _hoisted_24 = { class: "item-details-error-field px-2 py-2 align-top" }
const _hoisted_25 = {
  key: 0,
  class: "item-details-error-message"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "error"
}, null, -1)
const _hoisted_27 = { class: "item-details-error-field px-2 py-2 align-top" }
const _hoisted_28 = {
  key: 0,
  class: "item-details-error-message"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "error"
}, null, -1)
const _hoisted_30 = { class: "px-2 py-2 align-top" }
const _hoisted_31 = { class: "px-2 py-2 align-top" }
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "h-4 w-4",
  alt: "delete"
}, null, -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  colspan: 6,
  class: "px-4 py-2"
}
const _hoisted_35 = { class: "item-details-header-text text-black-lp-300" }
const _hoisted_36 = {
  "data-testid": "booking-v4-item-details-footer-total",
  class: "text-16px font-bold text-black-lp-300"
}
const _hoisted_37 = {
  key: 0,
  "data-testid": "booking-v4-item-details-footer-estimated",
  class: "ml-1 text-xs font-normal text-gray-lp-600"
}
const _hoisted_38 = {
  key: 0,
  class: "item-details-border-top flex items-start rounded-b-xl border-t px-3 py-2 text-14px font-normal text-gray-lp-300"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "item-details-info-icon mt-0.5 flex-shrink-0 rounded-full",
  alt: "info"
}, null, -1)
const _hoisted_40 = { class: "flex flex-col gap-1" }
const _hoisted_41 = { class: "font-semibold text-sm" }
const _hoisted_42 = { class: "list-disc pl-3" }
const _hoisted_43 = {
  key: 0,
  "data-testid": "booking-v4-item-details-deminimis-infobar"
}
const _hoisted_44 = { class: "font-bold" }
const _hoisted_45 = {
  key: 1,
  "data-testid": "booking-v4-item-details-import-warning-infobar"
}
const _hoisted_46 = {
  key: 2,
  "data-testid": "booking-v4-item-details-self-clearance-infobar"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalAllCommodityV4 = _resolveComponent("ModalAllCommodityV4")!

  return (!_ctx.hiddenCipl)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.goods.itemDetails.title")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("table", _hoisted_4, [
            _createVNode("thead", null, [
              _createVNode("tr", _hoisted_5, [
                _hoisted_6,
                _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.itemName")), 1),
                _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.quantity")), 1),
                _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.unitPrice")), 1),
                _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.totalPrice")), 1),
                _hoisted_11
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: item.id,
                  "data-testid": `booking-v4-item-details-row-${item.id}`
                }, [
                  _createVNode("td", _hoisted_12, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_13, [
                    _createVNode("div", {
                      class: ["item-details-commodity-field item-details-error-field relative", {
                  'has-hs-code': !!item.hsCode,
                  'has-special-handling':
                    item.isQuarantine || item.isDangerousGoods
                }]
                    }, [
                      _createVNode(_component_SelectSearch, {
                        id: `booking-v4-item-details-input-name-${item.id}`,
                        idInput: `booking-v4-item-details-commodity-${item.id}`,
                        isDisabled: _ctx.disabledCipl,
                        options: _ctx.commodityOptions,
                        modelValue: _ctx.commodityModel(item),
                        isLoading: _ctx.loadingSearch,
                        keyName: "name",
                        keyValue: "code",
                        placeholder: _ctx.$t('bookingV4.goods.cipl.placeholder.itemName'),
                        errorMessage: "bookingV4.goods.commodity.notFound",
                        maxHeight: "270px",
                        customBorderRadiusInput: "rounded-lg",
                        customClassInput: "item-details-select-input",
                        openIcon: '',
                        closeIcon: '',
                        useInfiniteScroll: "",
                        autoUpDown: "",
                        serverSide: false,
                        isShowErrorIndicator: !!_ctx.rowError(item.id, 'name'),
                        errorCaption: "",
                        hideErrorIcon: "",
                        onClickViewAll: ($event: any) => (_ctx.openCommodityModal(index)),
                        onScrolled: _ctx.fetchCommodityListInfiniteScroll,
                        onFocus: ($event: any) => (_ctx.onCommodityFocus(index)),
                        onFilter: ($event: any) => (_ctx.handleInputCommodity($event, index)),
                        onBlur: ($event: any) => (_ctx.touchField(item.id, 'name')),
                        "onUpdate:modelValue": ($event: any) => (_ctx.onCommodityModelUpdate($event, index))
                      }, {
                        "custom-option": _withId(({ item: commodity }) => [
                          _createVNode("div", _hoisted_14, [
                            _createVNode("span", null, _toDisplayString(commodity.name), 1),
                            _createVNode("div", _hoisted_15, [
                              (commodity.isQuarantine)
                                ? (_openBlock(), _createBlock("span", _hoisted_16, " K "))
                                : _createCommentVNode("", true),
                              (commodity.isDangerousGoods)
                                ? (_openBlock(), _createBlock("span", _hoisted_17, " DG "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["id", "idInput", "isDisabled", "options", "modelValue", "isLoading", "placeholder", "isShowErrorIndicator", "onClickViewAll", "onScrolled", "onFocus", "onFilter", "onBlur", "onUpdate:modelValue"]),
                      (item.isQuarantine || item.isDangerousGoods)
                        ? (_openBlock(), _createBlock("div", _hoisted_18, [
                            (item.isQuarantine)
                              ? (_openBlock(), _createBlock("span", _hoisted_19, " K "))
                              : _createCommentVNode("", true),
                            (item.isDangerousGoods)
                              ? (_openBlock(), _createBlock("span", _hoisted_20, " DG "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("button", {
                        type: "button",
                        "data-testid": 
                    `booking-v4-item-details-button-other-${item.id}`
                  ,
                        class: "item-details-other-button z-10 whitespace-nowrap text-red-lp-1200",
                        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"])),
                        onClick: ($event: any) => (_ctx.openCommodityModal(index))
                      }, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.otherCommodity")), 41, ["data-testid", "onClick"]),
                      (item.hsCode)
                        ? (_openBlock(), _createBlock("span", _hoisted_21, " HS code " + _toDisplayString(item.hsCode), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.rowError(item.id, 'name'))
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("span", null, _toDisplayString(_ctx.translatedRowError(item.id, "name")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_24, [
                    _createVNode(_component_LpInput, {
                      id: `booking-v4-item-details-input-quantity-${item.id}`,
                      placeholder: "bookingV4.goods.cipl.placeholder.quantity",
                      disabled: _ctx.disabledCipl,
                      modelValue: item.quantity,
                      format: _ctx.formatQuantity,
                      marginVertical: "",
                      sizeProportional: "py-2.5",
                      error: !!_ctx.rowError(item.id, 'quantity'),
                      errorCaption: "",
                      errorIcon: false,
                      isErrorIconCaption: false,
                      "onUpdate:modelValue": ($event: any) => (_ctx.updateQuantity(index, $event)),
                      onBlur: ($event: any) => (_ctx.touchField(item.id, 'quantity'))
                    }, null, 8, ["id", "disabled", "modelValue", "format", "error", "onUpdate:modelValue", "onBlur"]),
                    (_ctx.rowError(item.id, 'quantity'))
                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode("span", null, _toDisplayString(_ctx.translatedRowError(item.id, "quantity")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_27, [
                    _createVNode(_component_LpInput, {
                      id: `booking-v4-item-details-input-price-${item.id}`,
                      placeholder: "bookingV4.goods.cipl.placeholder.unitPrice",
                      modelValue: item.goodsPrice,
                      format: _ctx.formatGoodsPrice,
                      prefix: _ctx.currencyPrefix,
                      prefixPadding: "px-3",
                      marginVertical: "",
                      sizeProportional: "py-2.5",
                      error: !!_ctx.rowError(item.id, 'goodsPrice'),
                      errorCaption: "",
                      errorIcon: false,
                      isErrorIconCaption: false,
                      disabled: _ctx.disabledCipl,
                      "onUpdate:modelValue": ($event: any) => (_ctx.updateGoodsPrice(index, $event)),
                      onBlur: ($event: any) => (_ctx.touchField(item.id, 'goodsPrice')),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                    }, null, 8, ["id", "modelValue", "format", "prefix", "error", "disabled", "onUpdate:modelValue", "onBlur"]),
                    (_ctx.rowError(item.id, 'goodsPrice'))
                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode("span", null, _toDisplayString(_ctx.translatedRowError(item.id, "goodsPrice")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_30, [
                    _createVNode("div", {
                      "data-testid": `booking-v4-item-details-row-total-${item.id}`,
                      class: "flex h-9 items-center justify-start whitespace-nowrap text-14px"
                    }, _toDisplayString(_ctx.formatRowTotal(item)), 9, ["data-testid"])
                  ]),
                  _createVNode("td", _hoisted_31, [
                    (_ctx.modelValue.length > 1 && !_ctx.disabledCipl)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          "data-testid": 
                  `booking-v4-item-details-button-remove-${item.id}`
                ,
                          class: "flex h-9 items-center",
                          onClick: ($event: any) => (_ctx.removeRow(index))
                        }, [
                          _hoisted_32
                        ], 8, ["data-testid", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, ["data-testid"]))
              }), 128)),
              (_ctx.modelValue.length < _ctx.maxRows && !_ctx.disabledCipl)
                ? (_openBlock(), _createBlock("tr", _hoisted_33, [
                    _createVNode("td", _hoisted_34, [
                      _createVNode("button", {
                        type: "button",
                        "data-testid": "booking-v4-item-details-button-add",
                        class: "flex items-center gap-2 font-semibold text-red-lp-2400",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
                      }, [
                        _createVNode(_component_Icons, {
                          class: "text-red-lp-2400 w-5 h-5",
                          name: "grey-plus"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.cipl.addRow")), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", {
            class: ["item-details-gray-header item-details-border-top flex items-center justify-between border-t px-5", { 'rounded-b-xl': !_ctx.showInfobar }]
          }, [
            _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.footerTotal")), 1),
            _createVNode("span", _hoisted_36, [
              _createTextVNode(_toDisplayString(_ctx.footerTotalFormatted) + " ", 1),
              (_ctx.estimatedConversion)
                ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.footerEstimatedFormatted), 1))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (_ctx.showInfobar)
            ? (_openBlock(), _createBlock("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.senderInfo")), 1),
                  _createVNode("ul", _hoisted_42, [
                    (_ctx.showDeminimisInfobar)
                      ? (_openBlock(), _createBlock("li", _hoisted_43, [
                          _createTextVNode(_toDisplayString(_ctx.deminimisMessagePrefix) + " ", 1),
                          _createVNode("strong", _hoisted_44, _toDisplayString(_ctx.deminimisThresholdFormatted), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showImportDocInfobar)
                      ? (_openBlock(), _createBlock("li", _hoisted_45, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.importDocWarning")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.showSelfClearanceInfobar)
                      ? (_openBlock(), _createBlock("li", _hoisted_46, _toDisplayString(_ctx.$t("bookingV4.goods.cipl.selfClearanceWarning")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showCommodityModal)
          ? (_openBlock(), _createBlock(_component_ModalAllCommodityV4, {
              key: 0,
              recommendedCommodities: _ctx.recommendedCommodities,
              searchResults: _ctx.modalSearchResults,
              categories: _ctx.commodityCategories,
              categoryCommodities: _ctx.categoryCommodities,
              selectedCategoryCode: _ctx.selectedCategoryCode,
              isForeign: _ctx.isForeign,
              loading: _ctx.loadingModal,
              loadingCategory: _ctx.loadingCategories,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCommodityModal = false)),
              onSearch: _ctx.searchModalCommodities,
              onSelectCategory: _ctx.selectCommodityCategory,
              onSelect: _ctx.selectModalCommodity
            }, null, 8, ["recommendedCommodities", "searchResults", "categories", "categoryCommodities", "selectedCategoryCode", "isForeign", "loading", "loadingCategory", "onSearch", "onSelectCategory", "onSelect"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})